module.exports = "<div class=\"row\">\n\t<div class=\"col-md-6 center\">\n\t\t<div ng-show=\"!authenticated\">\n\t\t\t<h2>\n\t\t\t\tPlease <a ng-show=\"!authenticated\" href=\"signup\">Sign Up</a> to use StudioNinja\n\t\t\t</h2>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/js/components/home/anonymousHome.component.html
// module id = ./web/js/components/home/anonymousHome.component.html
// module chunks = 0